import React from "react";
import MDCTooltip from "./MDCTooltip";

// Material UI
import { styled } from "@mui/material/styles";
import { Select, MenuItem, Grid } from "@mui/material";

const StyledSelect = styled(Select)(({ theme, error }) => ({
  "& .MuiSelect-select": {
    background: theme.palette.MDCColors?.color21,
    border: error
      ? `2px solid ${theme.palette.MDCColors?.errorDanger}`
      : `2px solid ${theme.palette.MDCColors?.color23}`,
    color: theme.palette.MDCColors?.color18,
    fontFamily: theme.palette.typography?.fontFamily || "inherit",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginTop: "0.625rem",
    fontSize: "1rem",
    padding: "0.563rem 0 0.438rem 0.625rem",
    height: "calc(1rem + 0.125rem)",
    borderRadius: "5px",
    backgroundColor: error ? "rgba(236, 88, 103, 0.3)" : undefined,
    "&:focus": {
      backgroundColor: error
        ? "rgba(236, 88, 103, 0.3)"
        : theme.palette.MDCColors?.color21,
      borderRadius: "5px",
    },
  },
  "& .MuiSelect-icon": {
    top: "calc(50% - 0.625rem)",
    color: theme.palette.MDCColors?.color23,
  },
  "&.Mui-disabled": {
    "& .MuiSelect-select": {
      border: "0px",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.MDCColors?.disabledColor,
    },
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: theme.palette.typography?.fontFamily || "inherit",
}));

const MDCSelectWithTooltip = (props) => {
  const {
    value,
    handleChange,
    options,
    name,
    disabled,
    error,
    placeholder,
    disableEmpty,
  } = props;

  return (
    <>
      <StyledSelect
        name={name}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        displayEmpty
        fullWidth
        error={error}
        variant="standard"
        disableUnderline
      >
        <StyledMenuItem disabled={disableEmpty} value="">
          <div>{placeholder}</div>
        </StyledMenuItem>
        {options?.map((option, index) => (
          <StyledMenuItem key={index} value={option?.header}>
            <MDCTooltip
              placement={"right"}
              title={option?.description}
              key={index}
            >
              <Grid sx={{ width: "100%" }}>{option?.header}</Grid>
            </MDCTooltip>
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </>
  );
};

export default MDCSelectWithTooltip;
